module.exports = __webpack_public_path__ + "static/media/body_health-min.46a7da4d.jpg";